import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { CHECKOUT_URL, PRICE, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
export function FinalCTA() {
  return <section className="border-t-4 border-tech bg-white py-5 sm:py-7" data-id="element-41" data-mp="c83pjkbwtm5j">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-42" data-mp="84e24y6z1am3">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-43" data-mp="m4ykjt8z54f2">
          UNE DERNIÈRE <span className="text-tech" data-id="element-44" data-mp="h5vdk39foo4g">QUESTION</span>
        </h2>
        <div className="mx-auto mt-1.5 max-w-3xl space-y-1 text-center text-sm leading-snug text-steel sm:text-base" data-id="element-45" data-mp="h5lnkfoe2gyr">
          <p data-id="element-46" data-mp="vwkt1htxgpe4">Combien de fois avez-vous regardé une image en espérant reconnaître ce qu’il fallait…</p>
          <p data-id="element-47" data-mp="qy15xe3ll7k6">
            <strong className="font-semibold text-navy" data-id="element-48" data-mp="14vg1z1ocwdl4">
              sans savoir vraiment quoi regarder en premier ni dans quel ordre ?
            </strong>
          </p>
          <p data-id="element-49" data-mp="zua5qtvhm86u">
            Vous pouvez continuer à chercher dans des cours, des polycopiés et des notes
            dispersées. Ou ouvrir un seul système visuel organisé.
          </p>
          <p data-id="element-50" data-mp="2h49iducnklu0">
            <strong className="font-semibold text-navy" data-id="element-51" data-mp="2h5u3yugzoufq">
              Repérer. Analyser. Comparer. Puis conclure.
            </strong>
          </p>
        </div>

        <MockupImage className="mt-2" data-id="element-52" data-mp="2r2ypqt6xanw0" />

        <div className="mt-2 text-center" data-id="element-53" data-mp="2qzuj7p5zjg26">
          <p className="font-heading text-xl font-extrabold uppercase leading-tight text-navy sm:text-3xl" data-id="element-54" data-mp="2v4ak1c0qrxaj">
            🩻 {PRODUCT}
          </p>
          <p className="mx-auto mt-1 max-w-2xl font-display text-xs font-semibold uppercase leading-tight tracking-wide text-steel sm:text-base" data-id="element-55" data-mp="300iw2gjn7adh">
            {PRODUCT_TAGLINE}
          </p>
          <p className="mt-1 font-display text-2xs font-bold uppercase tracking-wide text-tech sm:text-sm" data-id="element-56" data-mp="39rn9hbto6n67">
            Anatomie • Techniques • Sémiologie • Protocoles • Cas illustrés • Outils
          </p>
        </div>

        <div className="mt-3 flex flex-col items-center" data-id="element-57" data-mp="3iqqskfsu72kp">
          <p className="mb-2 text-center font-display text-base font-extrabold uppercase leading-tight text-navy sm:text-xl" data-id="element-58" data-mp="1jp4wpxmojdr1">
            🔥 OBTENEZ LE SYSTÈME COMPLET AUJOURD’HUI — <span className="text-tech" data-id="element-59" data-mp="1sh6ufo5d6fxm">{PRICE}</span>
          </p>
          <CTAButton href={CHECKOUT_URL} data-id="element-60" data-mp="1sihxtmuwdlo7">🩻 OUI ! JE VEUX {PRODUCT}</CTAButton>
          <TrustLine items={['Accès immédiat • Livraison numérique', '🛡️ Garantie de 7 jours']} data-id="element-61" data-mp="1nonggq2rlisa" />
        </div>
      </div>
    </section>;
}